<template>
  <router-view v-slot="{ Component }">
    <KeepAlive :include="keepAlivePage">
      <component :is="Component" />
    </KeepAlive>
  </router-view>
</template>
<script>
import {mapGetters} from 'vuex'
export default {
  computed:{
    ...mapGetters('page', ['getStickyTabs']),
    keepAlivePage(){
      let pageName = [];
      this.getStickyTabs.forEach(item=>{
        if(item.name !== 'main'){
          pageName.push(item.name);
        }
      });
      return pageName
    }
  },
}
</script>
<style scoped>
* {
  font-family: "Helvetica Neue", Helvetica, Arial, "PingFang SC", "Hiragino Sans GB", "Heiti SC", "Microsoft YaHei", "WenQuanYi Micro Hei", sans-serif;

}
</style>

